// @flow

import * as React from "react";
import { Link } from "react-router-dom";

import "./Brand.css";

const Brand = () => {
  return (
    <div className="Brand">
      <Link to="/">Think Again</Link>
    </div>
  );
};

export default Brand;



// WEBPACK FOOTER //
// ./src/components/Brand/Brand.js